import { render } from "./PanelEditorField.vue?vue&type=template&id=1d544a7a&scoped=true&ts=true"
import script from "./PanelEditorField.vue?vue&type=script&lang=ts"
export * from "./PanelEditorField.vue?vue&type=script&lang=ts"

import "./PanelEditorField.vue?vue&type=style&index=0&id=1d544a7a&scoped=true&lang=css"

import exportComponent from "/home/steffen/IdeaProjects/Antara/src/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d544a7a"]])

export default __exports__